// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/company_info_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/company_info_model.proto.
 */
export const file_bffuser_v1_company_info_model: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL2NvbXBhbnlfaW5mb19tb2RlbC5wcm90bxIKYmZmdXNlci52MSIwCgtDb21wYW55SW5mbxITCgtyZXRhaWxlcl9pZBgBIAEoCRIMCgRuYW1lGAIgASgJQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM");

/**
 * CompanyInfo mirrors internalapi.v1.CompanyInfo for the frontend: the
 * organization's registered retail electricity provider identity shown on
 * the admin hub company info card and used to auto-assemble the JEPX note
 * discrimination comment for emission factor linking.
 *
 * @generated from message bffuser.v1.CompanyInfo
 */
export type CompanyInfo = Message<"bffuser.v1.CompanyInfo"> & {
  /**
   * Registered retail electricity provider ID (登録小売電気事業者 ID).
   * 5 uppercase alphanumeric characters per the METI registration list.
   *
   * @generated from field: string retailer_id = 1;
   */
  retailerId: string;

  /**
   * Registered retail electricity provider name (contract name).
   *
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message bffuser.v1.CompanyInfo.
 * Use `create(CompanyInfoSchema)` to create a new message.
 */
export const CompanyInfoSchema: GenMessage<CompanyInfo> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_company_info_model, 0);

